import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Location} from '@angular/common';
import { AlertaConfirmDialog } from '../alerta-confirm';
import { AlertaSimplesDialog } from '../alerta-simples';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { TamasAlunoService } from '../tamas-aluno.service';

@Component({
  selector: 'app-inst-contato',
  templateUrl: './inst-contato.component.html',
  styleUrls: ['./inst-contato.component.css']
})
export class InstContatoComponent implements OnInit {
  @ViewChild("nomeInput") nomeInput: ElementRef;
  @ViewChild("celularInput") celularInput: ElementRef;
  @ViewChild("emailInput") emailInput: ElementRef;
  @ViewChild("cidadeInput") cidadeInput: ElementRef;
  @ViewChild("msgInput") msgInput: ElementRef;
  nome: any = '';
  email: any = '';
  celular: any = '';
  cidade: any = '';
  tiponegocio: any = '';
  msg: any = '';
  hideCL: boolean = false;
  hideForm: boolean = false;
  public maskTelefone = ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/,/\d/,/\d/, '-', /\d/, /\d/, /\d/, /\d/];
  constructor(private route: ActivatedRoute, private _location: Location, public router: Router,  public dialog: MatDialog, public tmaService: TamasAlunoService) { }

  ngOnInit() {
    this.tmaService.eventoFS(true);
    this.hideCL = true;
  }

  ngOnDestroy(){
    console.log("destroy");
    this.tmaService.eventoFS(false);
  }


  enviarContato() : void{
    //validar

    if (this.nome.length <= 3) {
      const nomeInsuf = this.dialog.open(AlertaSimplesDialog, {
          data: {textoAlerta: "Por favor insira seu nome"}
      });
      nomeInsuf.afterClosed().subscribe(qq1 =>{
          this.nomeInput.nativeElement.focus();
      });
      return ;
    }

    if (this.celular.length < 12) {
      const celularInsuf = this.dialog.open(AlertaSimplesDialog, {
          data: {textoAlerta: "Por favor digite o celular  DDD + 9 dígitos"}
      });
      celularInsuf.afterClosed().subscribe(qq1 =>{
          this.celularInput.nativeElement.focus();
      });
      return ;
    }

    if (this.email == '') {
        const emailInsuf = this.dialog.open(AlertaSimplesDialog, {
            data: {textoAlerta: "Por favor insira seu e-mail"}
        });
        emailInsuf.afterClosed().subscribe(qq1 =>{
            this.emailInput.nativeElement.focus();
        });

        return ;
    }
    else {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.email);
        console.log("R " + re);
        if (re !== true) {
            const emailInv = this.dialog.open(AlertaSimplesDialog, {
                data: {textoAlerta: "E-mail invalido, por favor verifique se digitou corretamente"}
            });
            return ;
        }
    }

    if (this.cidade == '') {
      const cidadeInsuf = this.dialog.open(AlertaSimplesDialog, {
          data: {textoAlerta: "Por favor informe a sua cidade"}
      });
      cidadeInsuf.afterClosed().subscribe(qq1 =>{
          this.cidadeInput.nativeElement.focus();
      });
      return ;
    }

    if (this.msg == '') {
      const tiponegocio = this.dialog.open(AlertaSimplesDialog, {
          data: {textoAlerta: "Por favor digite sua mensagem"}
      });
      return ;
    }


    var objForm = "";
    objForm = JSON.stringify({'nome': this.nome, 'email' : this.email, 'celular': this.celular, 'tiponegocio': this.tiponegocio, 'cidade': this.cidade, 'mensagem' : this.msg});
    //ok just send
    let postParams = {
      dadosForm: objForm
    }
    this.hideCL = false;
      //var dadosU = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&idpaciente=' + this.idPaciente;
      this.tmaService.novoContatoSimples(postParams).subscribe((qRes) => {
        this.hideCL = true;
        console.log(qRes);
        if (qRes['res'] == 'done') {
          //redirecionar para finalizado
          this.hideForm = true;
        }
        else {
          const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: { textoAlerta: "Ocorreu um erro ao realizar o pedido. Tente novamente", iconAlerta: 'warning' }
          })
        }
      },
      (error) => {
        this.hideCL = true;
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
        });
      })




  }

  goHome() :void{
    this.router.navigate(["/"]);
  }

  voltar(): void {
    //this._location.back();
    this.router.navigate(['/abertura']);
    // if(this.tmaService.paginaAnterior == "abertura"){
    //   this.router.navigate(['/abertura']);
    // }
    // else{
    //   this._location.back();
    // }
    
  }
}
